import React from 'react';
import * as Routes from '@/modules/routes';
import Icon from '@/components/ui/Icon';
import SPAButton from '../../shared/SPAButton';
import SPADropdown from '../../shared/SPADropdown';
import { SlideShowParent, useCreateLessonGuide } from './useLessonGuides';

interface AddLessonGuideMenuProps {
  label: string;
  parent: SlideShowParent;
  programId: number;
}

// The legacy page's two Add buttons as one menu. A new guide opens on its legacy slideshow page,
// as the legacy create did, so building can start at once.
const AddLessonGuideMenu = ({ label, parent, programId }: AddLessonGuideMenuProps) => {
  const create = useCreateLessonGuide(programId, parent);

  const add = (useNewBuilder: boolean) => create.mutate(useNewBuilder, {
    onSuccess: ({ id }) => window.location.assign(
      Routes.admin_slide_show_path(id, { parent_id: parent.id, parent_type: parent.type, program_id: programId }),
    ),
  });

  return (
    <SPADropdown>
      <SPADropdown.Trigger asChild>
        <SPAButton disabled={create.isLoading} size="md" variant="primary">
          {create.isLoading ? 'Adding…' : label}
          <Icon icon="ChevronDown" size={12} />
        </SPAButton>
      </SPADropdown.Trigger>
      <SPADropdown.Content align="end" className="tw-w-56">
        <SPADropdown.Item onSelect={() => add(true)}>New builder</SPADropdown.Item>
        <SPADropdown.Item onSelect={() => add(false)}>Classic builder</SPADropdown.Item>
      </SPADropdown.Content>
    </SPADropdown>
  );
};

export default AddLessonGuideMenu;
